import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function StickyCTABar() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > window.innerHeight * 0.9);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-156" data-mp="1lzuv8iks1hny">
      {visible && <motion.div initial={{
      y: 72,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 72,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-brand-line bg-brand-alt/95 px-4 py-3 shadow-[0_-4px_16px_rgba(27,42,91,0.08)] backdrop-blur" data-id="element-157" data-mp="1m0w9evx3ak9w">
          <div className="mx-auto flex max-w-3xl items-center justify-between gap-4" data-id="element-158" data-mp="m9xx1metrq3">
            <div className="hidden sm:block" data-id="element-159" data-mp="hwf7x2i4uo6x">
              <p className="font-display text-base font-bold text-brand-navy" data-id="element-160" data-mp="hukm7lz1es1s">
                10 Bände + 5 Boni
              </p>
              <p className="text-xs text-brand-gray" data-id="element-161" data-mp="7yrceacpdcnp">
                Einmalig 19 € · Sofort-Download
              </p>
            </div>
            <a href="https://kunst-startklar.impultienda.ar/checkout" className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-brand-orange px-6 py-3.5 text-xs font-extrabold uppercase tracking-[0.12em] text-white shadow-md transition-shadow duration-200 ease-out hover:shadow-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-orange focus-visible:ring-offset-2 sm:w-auto" data-id="element-162" data-mp="cwaq995hnnf4">
              Jetzt das Kunst-Paket sichern
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-163" data-mp="3bfrgl03hh366" />
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}